// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconAddCircle.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconAddCircle = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path fillRule="evenodd" clipRule="evenodd" d="M13.6569 13.6569C16.781 10.5327 16.781 5.46734 13.6569 2.34315C10.5327 -0.781049 5.46734 -0.781049 2.34315 2.34315C-0.781049 5.46734 -0.781049 10.5327 2.34315 13.6569C5.46734 16.781 10.5327 16.781 13.6569 13.6569ZM3.26508 7.07814L7.0781 7.07818L7.0781 3.26504L8.92186 3.265L8.92178 7.07822L12.735 7.07814L12.7349 8.92185L8.9219 8.92181V12.735L7.07818 12.735L7.07822 8.92178L3.265 8.92186L3.26508 7.07814Z" />
  </BaseIcon>
);

export default IconAddCircle;
